/**
 * Compare two variables, return true if equal, otherwise false
 *
 * @param {*} a
 * @param {*} b
 * @return {boolean}
 */
const isEqual = (a, b) => {
    if (a === b) {
        return true
    }

    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) {
            return false
        }

        for (let i = 0; i < a.length; i++) {
            if (!isEqual(a[i], b[i])) {
                return false
            }
        }

        return true
    }

    if (isPlainObject(a) && isPlainObject(b)) {
        let akeys = Object.keys(a).sort()
        let bkeys = Object.keys(b).sort()

        if (!isEqual(akeys, bkeys)) {
            return false
        }

        for (let i = 0; i < akeys.length; i++) {
            let key = akeys[i]
            if (!isEqual(a[key], b[key])) {
                return false
            }
        }

        return true
    }

    return false
}

function isPlainObject(o) {
    return Boolean(o) && o.constructor === {}.constructor
}

export { isEqual }
